// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-2ro0Y";
var _3 = "name-1H49V";
export { _1 as "__esModule", _2 as "root", _3 as "name" }
export default { "__esModule": _1, "root": _2, "name": _3 }
